import apiClient from '../client';

export interface UploadFileResponse {
  url: string;
}

export interface StorageService {
  uploadFile: (bucket: 'profile-pictures' | 'course-thumbnails' | 'portfolio-images', file: File) => Promise<string>;
  deleteFile: (bucket: 'profile-pictures' | 'course-thumbnails' | 'portfolio-images', path: string) => Promise<void>;
  getPublicUrl: (bucket: 'profile-pictures' | 'course-thumbnails' | 'portfolio-images', path: string) => Promise<string>;
}

/**
 * Upload a file to Supabase Storage via backend API
 */
export async function uploadFile(
  bucket: 'profile-pictures' | 'course-thumbnails' | 'portfolio-images',
  file: File
): Promise<string> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('bucket', bucket);

  const response = await apiClient.post<UploadFileResponse>('/storage/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }) as unknown as UploadFileResponse;

  return response.url;
}

/**
 * Delete a file from Supabase Storage via backend API
 */
export async function deleteFile(
  bucket: 'profile-pictures' | 'course-thumbnails' | 'portfolio-images',
  path: string
): Promise<void> {
  const encodedPath = encodeURIComponent(path);
  await apiClient.delete(`/storage/${bucket}/${encodedPath}`);
}

/**
 * Get public URL for a file in Supabase Storage via backend API
 */
export async function getPublicUrl(
  bucket: 'profile-pictures' | 'course-thumbnails' | 'portfolio-images',
  path: string
): Promise<string> {
  const encodedPath = encodeURIComponent(path);
  const response = await apiClient.get<{ url: string }>(`/storage/url/${bucket}/${encodedPath}`) as unknown as { url: string };
  return response.url;
}

export const storageService: StorageService = {
  uploadFile,
  deleteFile,
  getPublicUrl,
};
